import react from "react";
function Education() {
    return (
        <div className="education">
            <div className = "education-card">
            <h2 className="education-title">Education</h2>
            <p className="education-item">B.Tech in Computer Science - Greater Noida College (2023-2027)</p>
            <p className="education-item">Intermediate  - St Anthony School </p>
        </div>
        </div>
    );
}

export default Education;